export default __webpack_public_path__ + "static/media/group-option-hair-unselected.6e55bed9.svg";